
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/cyberark-vs-delinea",
      function () {
        return require("private-next-pages/compare/cyberark-vs-delinea.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/cyberark-vs-delinea"])
      });
    }
  